import { ToastTypes } from '@opengov/component-library-classic/classic';
import { viewActions } from '@opengov/component-library-classic/module/view';
import { EOgqlJobState, IOgqlJobResult } from '@opengov/ogql-types';
import { EQueryType, IReportConfiguration } from '@opengov/reporting-types';

import { reportExplorerActionCreators } from '../../../../reportExplorer/state';
import { IReportLocale } from '../../../locale';

import { runV0Query } from './runQueries';
import { MuiToastTypes } from '../../../helpers/utils';
import { reportActionCreators } from '../../../report/state';

export const handleReportCountQuery = (result: IOgqlJobResult, reportMsgs: IReportLocale): IOgqlJobResult => {
  switch (result.state) {
    case EOgqlJobState.finished: {
      const [[total]] = result.jobResult.data;

      reportExplorerActionCreators.updateReportTotalRowCount(total);

      break;
    }
    case EOgqlJobState.failed: {
      viewActions.showToast.create({
        type: ToastTypes.FAILURE,
        headerText: reportMsgs.query.failure.headerText,
        bodyText: reportMsgs.query.failure.bodyText
      });
      break;
    }
    // we cancelled it .. it's not an error
    case EOgqlJobState.cancelled:
      break;
    default:
      break;
  }
  return result;
};

interface IReportCountQuery {
  reportConfiguration: IReportConfiguration;
  reportMsgs: IReportLocale;
  useLargeScaleQueryLimit: boolean;
  useQueryService?: boolean;
  isStandardTemplate: boolean;
}

export const reportCountQuery = async ({
  reportConfiguration,
  reportMsgs,
  useLargeScaleQueryLimit,
  useQueryService,
  isStandardTemplate
}: IReportCountQuery): Promise<IOgqlJobResult | undefined> => {
  return runV0Query({
    reportId: reportConfiguration.reportId,
    queryType: EQueryType.fullReportCountQuery,
    body: reportConfiguration,
    useLargeScaleQueryLimit,
    useQueryService,
    isStandardTemplate
  })
    .then((result) => handleReportCountQuery(result, reportMsgs))
    .catch((e) => {
      console.error(e);
      reportActionCreators.toggleMuiToast({
        type: MuiToastTypes.FAILURE,
        headerText: reportMsgs.query.failure.headerText,
        bodyText: reportMsgs.query.failure.bodyText
      });
      return undefined;
    });
};
